import { render } from "./ProfitInput.vue?vue&type=template&id=bba9b434&scoped=true"
import script from "./ProfitInput.vue?vue&type=script&lang=js"
export * from "./ProfitInput.vue?vue&type=script&lang=js"

import "./ProfitInput.vue?vue&type=style&index=0&id=bba9b434&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bba9b434"]])

export default __exports__